import {gql} from "@irati/utils/gql"

import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import fullUser from "../fragments/fullUserV4"
import fullTeamV4 from "../fragments/fullTeamV4"

const query = gql`
  mutation UpdateUser($user: UserInput!, $withTeams: Boolean!, $withPreferences: Boolean!) {
    updateUser(user: $user) {
      ...fullUser
      userPreferences @include(if: $withPreferences) {
        birthdayPreferences
      }
      teams @include(if: $withTeams) {
        results {
          ...fullTeam
        }
      }
    }
  }
  ${fullUser}
  ${fullTeamV4}
`

export const updateUserKey = getQueryNames(query)[0]

export default query
